<script lang='ts'>
  import HelpCircle from '~/icons/HelpCircle.svelte';
  import ActionButton from '~/components/ActionButton.svelte';
  import { classicTutorialModal } from './classic/ClassicTutorialModal.svelte';
  import { dailyRulesModal } from './daily/DailyRulesModal.svelte';
  import { page } from '$app/state';

  const props: { iconOnly: boolean } = $props();

  const handleClick = () => {
    switch ((page.params.mode || page.route.id) as string) {
      case '/classic':
        classicTutorialModal.push(undefined, 'drawer');
        break;
      case 'daily':
      case 'mini':
        dailyRulesModal.push(undefined, 'drawer');
        break;
      case 'twist':
        dailyRulesModal.push(undefined, 'drawer');
    }
  };
</script>

<ActionButton onClick={handleClick}>
  <span class:icon-only={props.iconOnly}>
    <HelpCircle size="1.5em" />
  </span>
  {#if false}
    <div class="text">
      <div class="badge"></div>
    </div>
  {/if}
  {#if !props.iconOnly}
    How to play
  {/if}
</ActionButton>

<style>
  .text {
    position: relative;
  }
  .badge {
    position: absolute;
    top: -0.5em;
    right: 0;
    background-color: red;
    border-radius: 50%;
    width: 0.5em;
    height: 0.5em;
  }
  .icon-only {
    :global(svg) {
      scale: 1.25;
      margin: -1.25px -4px;
    }
    :global(circle) {
      display: none;
    }
  }
</style>
